import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
;
const SvgChevronDown = _ref => {
  let {
    primaryColor,
    colorMapping,
    ...props
  } = _ref;
  function getRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }
  const randomizedId = getRandomInt(1, 1000);
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    "data-component": "SvgChevronDown"
  }), React.createElement("path", {
    stroke: primaryColor,
    strokeWidth: 1.5,
    d: "m20 8-8 8-8-8"
  }));
};
SvgChevronDown.__name = 'SvgChevronDownchevron_down';
;
export default SvgChevronDown;